import React from 'react';
import { CouponValueTypeLabels } from '../../../../api/payments/coupons/domain/labels';
import { CouponScopeTag } from './CouponScopeTag';
import { formatCycleRange, formatRuleValue } from '../utils';
import { DiscountPricePreview } from './DiscountPricePreview';
import { JdsTag } from '../../../../components/jds/JdsTag';

const tag = () => <JdsTag label="Ao total" color="success" />;

export function getItemTargetLabel(discount) {
  if (discount.itemName) return discount.itemName;
  return discount.itemId ? `Produto #${discount.itemId}` : 'Produto sem nome';
}

// `||` (não `??`): plano com name vazio também cai no identificador.
export function getPlanTargetLabel(plansById, planId) {
  return plansById[planId]?.name || `Plano #${planId}`;
}

function getDiscountTargetLabel(discount, plansById) {
  const scope = discount.scope;
  if (scope === 'PLAN') {
    if (!discount.planId) return 'Em qualquer plano';
    return getPlanTargetLabel(plansById, discount.planId);
  }
  if (scope === 'ITEM') return getItemTargetLabel(discount);
  return tag();
}

export function CouponDiscountsTable({ discounts, plansById }) {
  if (discounts.length === 0) {
    return <span className="text-muted">Nenhum desconto configurado</span>;
  }

  return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
      <table className="table jds-table">
        <thead>
          <tr>
            <th>Aplicado a</th>
            <th>Tipo de desconto</th>
            <th>Valor</th>
            <th>Ciclos</th>
            <th>Produto/Plano</th>
          </tr>
        </thead>
        <tbody>
          {discounts.map((discount, index) => (
            <tr key={discount.id ?? index}>
              <td>
                <CouponScopeTag scope={discount.scope} />
              </td>
              <td>
                {CouponValueTypeLabels[
                  discount.valueType ?? discount.value_type
                ] ??
                  discount.valueType ??
                  discount.value_type}
              </td>
              <td>
                {formatRuleValue(discount)}
                {discount.scope === 'PLAN' && (
                  <DiscountPricePreview
                    plan={plansById[discount.planId]}
                    valueType={discount.valueType ?? discount.value_type}
                    value={discount.value}
                    hideLabel
                  />
                )}
              </td>
              <td>{formatCycleRange(discount.fromCycle, discount.toCycle)}</td>
              <td>{getDiscountTargetLabel(discount, plansById)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
